export const CONTAIN_Y = 'data-scroll-contain-y';
export const CONTAIN_X = 'data-scroll-contain-x';

const SCROLLABLE_OVERFLOW = new Set(['auto', 'scroll', 'overlay']);
const OVERFLOW_SLACK_PX = 1;

export interface ScrollBox {
  scrollHeight: number;
  clientHeight: number;
  scrollWidth: number;
  clientWidth: number;
}

export interface OverflowStyle {
  overflowX: string;
  overflowY: string;
}

export interface ScrollAxes {
  x: boolean;
  y: boolean;
}

const NO_AXES: ScrollAxes = { x: false, y: false };

export function overflowingAxes(box: ScrollBox): ScrollAxes {
  return {
    x: box.scrollWidth - box.clientWidth > OVERFLOW_SLACK_PX,
    y: box.scrollHeight - box.clientHeight > OVERFLOW_SLACK_PX,
  };
}

export function scrollableAxes(box: ScrollBox, readStyle: () => OverflowStyle): ScrollAxes {
  const overflowing = overflowingAxes(box);
  if (!overflowing.x && !overflowing.y) return NO_AXES;
  const style = readStyle();
  return {
    x: overflowing.x && SCROLLABLE_OVERFLOW.has(style.overflowX),
    y: overflowing.y && SCROLLABLE_OVERFLOW.has(style.overflowY),
  };
}

function setFlag(element: Element, name: string, on: boolean): void {
  if (element.hasAttribute(name) !== on) element.toggleAttribute(name, on);
}

export function installScrollContainers(doc: Document = document): () => void {
  const view = doc.defaultView;
  if (!view) return () => undefined;
  const root = doc.documentElement;

  const mark = (event: Event) => {
    for (let element = event.target instanceof Element ? event.target : null; element && element !== root && element !== doc.body; element = element.parentElement) {
      const current = element;
      const axes = scrollableAxes(current, () => view.getComputedStyle(current));
      setFlag(current, CONTAIN_Y, axes.y);
      setFlag(current, CONTAIN_X, axes.x);
    }
  };

  const passive = { capture: true, passive: true } as const;
  const events = ['pointerover', 'pointerdown', 'wheel', 'touchstart'] as const;
  for (const name of events) doc.addEventListener(name, mark, passive);
  return () => {
    for (const name of events) doc.removeEventListener(name, mark, passive);
  };
}
